export { default as ITeroSignContract } from './ITeroSignContract';
export * as Styled from './ITeroSignContract.styles';
